import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { User, UserAuthorities } from '../models/user.model';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '@evonik/ng-core';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    public currentUser: User | undefined;
    private baseUrl = '';

    constructor() {
        this.baseUrl = this.config.getConfig().get('apiBaseUrl');
    }

    hasANA3Auth(): boolean | undefined {
        return this.currentUser?.authorities?.includes(UserAuthorities.ANA3);
    }

    hasSpectraAuth(): boolean | undefined {
        return this.currentUser?.authorities?.includes(UserAuthorities.ANA3_UPLOAD_SPECTRA);
    }

    hasStdAuth(): boolean | undefined {
        return this.currentUser?.authorities?.includes(UserAuthorities.ANA3_UPLOAD_STD);
    }

    hasANA4AllowResult(): boolean | undefined {
        return this.currentUser?.authorities?.includes(UserAuthorities.ANA3_ALLOW_RESULT);
    }

    async loadUser(): Promise<void> {
        this.currentUser = await firstValueFrom(this.http.get<User>(`${this.baseUrl}/api/user`));
    }
}
